import { createContext, useContext, type ReactNode } from "react";

export interface PageOpsContextValue {
  saveCurrentPageToStore: () => void;
  loadPageToHooks: (pageData: any) => void;
  handleMapUpload: () => void;
  handleTokenUpload: () => void;
  pageCallbacks: {
    create: (name: string, parentPageId?: string) => void;
    rename: (pageId: string, name: string) => void;
    delete: (pageId: string) => void;
    activate: (pageId: string) => void;
    preview: (pageId: string) => void;
    returnToActive: () => void;
    reorder: (pageIds: string[]) => void;
  };
}

const PageOpsContext = createContext<PageOpsContextValue | null>(null);

export function PageOpsProvider({ value, children }: { value: PageOpsContextValue; children: ReactNode }) {
  return (
    <PageOpsContext.Provider value={value}>
      {children}
    </PageOpsContext.Provider>
  );
}

export function usePageOpsContext(): PageOpsContextValue {
  const ctx = useContext(PageOpsContext);
  if (!ctx) {
    throw new Error("usePageOpsContext must be used within a PageOpsProvider");
  }
  return ctx;
}
